import React from 'react';
import { edit, locked } from '../../../assets/images/dashboard-business';

type TInput = {
  title: string;
  description: string;
};
type TProps = {
  val: TInput[];
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
  islocked?: boolean;
};
const FinalFormBusinessComponent = ({ val, setStep, islocked = false, step }: TProps) => {
  const handleClick = () => {
    !islocked && setStep(step);
  };
  return (
    <div className='flex justify-between mb-3'>
      <div>
        {val.map((val, index) => (
          <div
            key={val.title + val.description}
            className={islocked ? 'opacity-25' : 'opacity-100'}
          >
            <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
              {val.title}
            </div>
            <div className='mb-3'>{val.description}</div>
          </div>
        ))}
      </div>
      <div>
        <img
          src={islocked ? locked : edit}
          alt='edit'
          className={islocked ? 'opacity-25' : 'opacity-100'}
          onClick={() => handleClick()}
        />
      </div>
    </div>
  );
};

export default FinalFormBusinessComponent;
